(function ($) {
  'use strict';

  let win          = $(window),
    header       = $('#header'),
    headerHeight = header.outerHeight(),
    body         = $('body'),
    menu         = $('.header-menu');
  submenu      = $('.submenu');
  const topBannerOffers = $('.top-banner-offers');
  init();

  // tlacitko menu
  $('#show-menu').click(toggleMainMenu);

  /*
    Zobrazi/skryje hlavní menu
    na mobilu se zobrazi menu pouze na kliknuti
  */
  function toggleMainMenu() {
    menu.toggleClass('hidden-sm hidden-xs');
    refreshMargin(); // prepocteme top margin body elementu
  }

  function init() {
    body.css({'margin-top' : headerHeight});
  }

  // zavirani/otevirani hlavicky pri scrollu
  let hideMenu     = false,
    initValue    = win.scrollTop();

  win.resize(() => {
    refreshMargin ();
  })


  //WEB-1125 drop down
  // if(!(window.location.host.split('.')[2] == 'sk') && window.location.pathname === '/') {
  //   const cancelButt = document.querySelector('.closeTopBanner');
  //   cancelButt.addEventListener('click', hideTopBanner);
  // }
  let cancelBanner = false;

  function hideTopBanner() {
    //1 display none a pridam animaci
    topBannerOffers.hide();
    cancelBanner = true;
  }

  function loadBanner(){
    const banner = document.querySelector('.top-banner-offers');
    document.body.click();
    banner.style.display ='';
    // $(".top-banner-offers").slideDown();
    document.body.click();
  }

  // //WEB-1125 drop down
  // if(!(window.location.host.split('.')[2] == 'sk') && window.location.pathname === '/') {
  //   window.addEventListener('resize', function(){
  //
  //     const topBannerOffers = $('.top-banner-offers');
  //     const banner = document.querySelector('.top-banner-offers');
  //     if(!cancelBanner) {
  //       if(window.innerWidth < 1024 && banner.style.display == ''){
  //         topBannerOffers.hide();
  //         document.body.click();
  //       } else if (window.innerWidth > 1024 && banner.style.display == 'none'){
  //         setTimeout(()=> loadBanner(),1000);
  //       }
  //     }
  //   });
  // }
  //
  // if(!(window.location.host.split('.')[2] == 'sk') && window.location.pathname === '/') {
  //   window.addEventListener('scroll', function(e) {
  //     const banner = document.querySelector('.top-banner-offers');
  //     if(!cancelBanner){
  //       if (window.pageYOffset > 0){
  //         refreshMargin();
  //         banner.style.display = 'none';
  //       }
  //       if(window.pageYOffset == 0){
  //         if(window.innerWidth >1024) {
  //           setTimeout(()=> loadBanner(),300);
  //         }
  //       }
  //     }
  //   });
  // }

  function refreshMargin () // prepocita ma
  {

    const headingHeadroom = document.querySelector('.headroom');

    const headerHeight = header.outerHeight();
    if(headerHeight > 400 && headingHeadroom.classList.contains('headroom--unpinned')) {
      body.css({'margin-top' : 48});
      headroom.offset = 0;

    } else if (headerHeight > 400 && headingHeadroom.classList.contains('headroom--pinned')) {
      const banner = document.querySelector('.top-banner-offers');
      // if(removeBanner) banner.display.style = 'none';
      body.css({'margin-top' : headerHeight});
      headroom.offset = 0;

    }else if (headerHeight > 400 && headingHeadroom.classList.contains('headroom--top')) {
      body.css({'margin-top' : headerHeight});
      headroom.offset = 0;

    }
    else {

      body.css({'margin-top' : headerHeight});
      headroom.offset = headerHeight;

    }




    // if(banner.style.display != ''){
    //   headerHeight = header.outerHeight();
    //   body.css({'margin-top' : headerHeight});
    // }
    // else if (win.scrollTop() > 40 && headingHeadroom.offsetHeight > 400)
    //   body.css({'margin-top' : 460});
    // else if(win.scrollTop() == 0 && headingHeadroom.offsetHeight > 400)
    //   body.css({'margin-top' : headerHeight});
    //
    // headroom.offset = 0;
  }

  //  win.scroll(() => {
  //    if (win.scrollTop() > headerHeight)
  //      if (initValue < win.scrollTop() && hideMenu == false) {
  //        initValue = win.scrollTop();
  //        header.addClass('menu-is-hidden').css({'top' : `-${headerHeight}px`});
  //        menu.addClass('hidden-xs');
  //      }
  //      else {
  //        initValue = win.scrollTop();
  //        header.removeClass('menu-is-hidden').css({'top' : '0px'});
  //      }
  //  });

  //$('#header').headroom();
  //
  //
  // grab an element
  var myElement = document.querySelector('#header');
  // construct an instance of Headroom, passing the element
  var headroom  = new Headroom(myElement,{
    offset : headerHeight,
    onUnpin : function() {
      submenu.css({'display':'none'});
      menu.addClass('hidden-xs');
      refreshMargin ();
    },
    onPin : function() {
      header.removeClass('menu-is-hidden');
      refreshMargin ();
    }
  });
  // initialise
  headroom.init();


  //console.log('' + headroom.offset);

  // new

  // zpozdeni otevirani submenu
  let timerSubmenu,
    nextServices = $('#header nav .dalsi-sluzby'),
    submenu      = nextServices.find('.submenu');

  // po kliku kamkoliv jinam nez na submenu toto submenu zavreme
  $('body').on('click', e => {
    let submenuAnchors = submenu.find('a');
    if (!submenuAnchors.is(e.target) && submenu.hasClass('hide-on-click'))
      submenu.hide();
    refreshMargin ();
  });
  nextServices.hover(
    () => {
      clearTimeout(timerSubmenu);
      submenu.show().addClass('hide-on-click');

    }, () => {
      timerSubmenu = setTimeout(() => {
        submenu.hide().removeClass('hide-on-click');
        refreshMargin ();
      }, 1000);
    }
  );
})(jQuery);


/* Web-623 fix, hide Header when scroll on anchor */
if (location.href.includes('#')) {
  const div = document.createElement('div') /* Na Chrom Browser se stranka odsazuje tesne nad nadpis,
                                               vytvorenim <div></div> odsadime o 50px */
  /* div.setAttribute('style', 'margin-top: -50px; padding-top: 50px;');
  document.querySelector('#kyvadlova-doprava').appendChild(div)  */
  document.querySelector('#header').classList.add('headroom--unpinned')
}
